import * as React from "react";
import { typeCompact14Medium } from "@traceair/tds";
import { classes, style } from "typestyle";

interface IProps {
  className?: string;
  borderBottomColor?: string;
  backgroundColor?: string;
  height?: string;
  leftIcon: React.ReactNode;
  leftLabel: string | React.ReactNode;
  rightLabel?: string | React.ReactNode;
  rightIcon?: React.ReactNode;
  onLeftIconClick?: () => void;
  onLeftLabelClick?: () => void;
  onRightLabelClick?: () => void;
  onRightIconClick?: () => void;
}

export default function SidebarItem({
  className,
  borderBottomColor,
  backgroundColor,
  height,
  leftIcon,
  leftLabel,
  rightLabel,
  rightIcon,
  onLeftIconClick,
  onLeftLabelClick,
  onRightLabelClick,
  onRightIconClick,
}: IProps) {
  const theHeight = height || "48px";

  return (
    <div
      className={classes(
        style({
          display: "flex",
          flex: 1,
          flexDirection: "row",
          alignItems: "center",
          boxSizing: "border-box",
          backgroundColor: backgroundColor || "#fff",
          paddingLeft: "4px",
          borderBottom: borderBottomColor
            ? `1px solid ${borderBottomColor}`
            : "none",
        }),
        className,
      )}
    >
      {/* left icon */}
      {leftIcon && (
        <div
          onClick={onLeftIconClick || noop}
          className={style({
            display: "flex",
            height: theHeight,
            width: "40px",
            alignItems: "center",
            justifyContent: "center",
            cursor: onLeftIconClick ? "pointer" : "default",
          })}
        >
          {leftIcon}
        </div>
      )}
      {/* left label */}
      {!leftIcon && <div className={style({ width: "12px" })} />}{" "}
      {/* HACK: padding-left if no icon */}
      <div
        onClick={onLeftLabelClick}
        className={classes(
          style({
            flex: 1,
            height: theHeight,
            display: "flex",
            alignItems: "center",
            overflow: "hidden",
            paddingRight: "10px",
            cursor: onLeftLabelClick ? "pointer" : "default",
          }),
          typeCompact14Medium,
        )}
      >
        <span
          title={typeof leftLabel === "string" ? leftLabel : ""}
          className={style({
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
          })}
        >
          {leftLabel}
        </span>
      </div>
      {/* right label */}
      {rightLabel && (
        <div
          onClick={onRightLabelClick}
          className={style({
            color: "rgba(0,0,0,0.54)",
            fontSize: "14px",
            lineHeight: "16px",
            cursor: onRightLabelClick ? "pointer" : "default",
          })}
        >
          {rightLabel}
        </div>
      )}
      {/* right icon */}
      {rightIcon && (
        <div
          onClick={onRightIconClick || noop}
          className={style({
            display: "flex",
            height: theHeight,
            width: theHeight,
            alignItems: "center",
            justifyContent: "center",
            cursor: onRightIconClick ? "pointer" : "default",
          })}
        >
          {rightIcon}
        </div>
      )}
    </div>
  );

  function noop(): void {
    return null;
  }
}
